<template>
  <ValidationObserver ref="PublicVaild" >
    <slot name="PageBody"></slot>
  </ValidationObserver>

</template>

<script>
export default {
props:{
  ImgListRef:{
        type:Array,
        default:()=> 
        []
  },
  VideoListRef:{
        type:Array,
        default:()=> 
        []
   },
   productCatsRef:{
    type:Array,
        default:()=> 
        []
   },
   MediaListRef:{
    type:Array,
        default:()=> 
        []
   }
},
data(){
    return {
      temp_MediaListRef: this.MediaListRef
    };
},
watch:{
  MediaListRef(val){
    this.temp_MediaListRef = val;
  },
},
computed:{

},
mounted(){  

},
methods:{
  async validate(isSkipAlert = false){
    var data = [];

    var resultData = 
        {
          valid:true,
          fIldData:[]
        }
    var OtherValid= await this.validateOthers(data, isSkipAlert);
    return new Promise((resolve, reject) => {
      this.$refs.PublicVaild.validate().then(valid => {
        if(!valid)
        {
          if(!isSkipAlert) {
            this.$Alert(0,this.$t('lbl_EMPBE_Please_mandatory_And_exceptions_Tips'));
          }
          this.scrollToError(data);
        }
        //返回 {验证状态:true/false,未通过字段:[""]}
        // console.log("验证状态",valid,OtherValid,resultData)
        resultData.valid = valid && OtherValid;
        resultData.fIldData = data;
        resolve(resultData)
      }).catch(err => {
        reject(err)
      })
    })
  },
  //必填验证其他内容
  async validateOthers(data, isSkipAlert = false)
  {
    var productCatsStatus=await this.validateProductCat(data, isSkipAlert);
    var PhotoSatus = await  this.validatePhoto(data,productCatsStatus, isSkipAlert);
    var videoStatus = await  this.validateVideo(data,PhotoSatus, isSkipAlert);
    const mediaStatus = await this.validateMedia(data,videoStatus, isSkipAlert);
    // console.log("产品类别验证："+productCatsStatus+"图片验证",PhotoSatus,"视频验证",videoStatus)
    return productCatsStatus&&PhotoSatus && videoStatus && mediaStatus;
  },
  //必填验证图片
  async validatePhoto(data,preStatus, isSkipAlert = false){
    return new Promise((resolve, reject) => {
      if(this.ImgListRef.length>0)
      {
        this.ImgListRef.forEach(element  => {
          var refOBject;
          if(element.includes("."))
          {
            var obj =this.$parent.$parent;
            var refOBjectSplit = element.split('.');
            refOBjectSplit.forEach(item => {
              obj=obj?.$refs[item];
            });
            refOBject =obj;
          }else
          {
            refOBject =this.$parent.$parent.$refs[element];
          }
          if(refOBject)
          {
            if(Array.isArray(refOBject)){
            refOBject.forEach(element => {
                    if(!element.temp_imageArray || element.temp_imageArray.length<1){
                      //记录他的ref 内容就行
                      data.push(element.componentId);
                      //触发一次样式必填
                      element.IsRequiredStyle=true;
                      if(preStatus){
                        if (!isSkipAlert) {
                          this.$Alert(0,this.$t('lbl_EMPBE_Please_Upload_Photo'));
                        }
                      this.VideoAndImgScrollToError(element.$el,650);
                      }
                     
                      resolve(false);
                      return;
                    }
                });
            }
            else
            {
              if(!refOBject.temp_imageArray || refOBject.temp_imageArray.length<1){
                      //记录他的ref 内容就行
                      data.push(element);
                      //触发一次样式必填
                      refOBject.IsRequiredStyle=true;
                       if(preStatus){
                        if (!isSkipAlert) {
                          this.$Alert(0,this.$t('lbl_EMPBE_Please_Upload_Photo'));
                        }
                      this.VideoAndImgScrollToError(refOBject.$el,650);
                       }
                      resolve(false);
                      return;
              }
            }
          }
           
         });
      }
      resolve(true);
    });
  },
  //必填验证视频
  async validateVideo(data,preStatus, isSkipAlert = false){
    return new Promise((resolve, reject) => {
      if(this.VideoListRef.length>0)
      {
        this.VideoListRef.forEach(async element => {
            var refOBject;
            if(element.includes("."))
            {
              var obj =this.$parent.$parent;
              var refOBjectSplit = element.split('.');
              refOBjectSplit.forEach(item => {
                  obj=obj?.$refs[item];
              });
              refOBject =obj;
            }else
            {
              refOBject =this.$parent.$parent.$refs[element];
            }
            if(refOBject)
            {
                if(Array.isArray(refOBject)){
                  refOBject.forEach(element => {
                        if(!element.temp_videoArray || element.temp_videoArray.length<1){
                          //记录他的ref内容就行
                          data.push(element.componentId);
                          //触发一次样式必填
                          element.IsRequiredStyle=true;
                           if(preStatus){
                            if (!isSkipAlert) {
                              this.$Alert(0,this.$t('lbl_EMPBE_Please_Upload_Video'));
                            }
                          this.VideoAndImgScrollToError(element.$el,650);
                           }
                          resolve(false);
                          return;
                        }
                    });
                }
                else
                {
                  if(!refOBject.temp_videoArray || refOBject.temp_videoArray.length<1){
                          //记录他的ref内容就行
                          data.push(element);
                          //触发一次样式必填
                          refOBject.IsRequiredStyle=true;
                          if(preStatus){
                            if (!isSkipAlert) {
                              this.$Alert(0,this.$t('lbl_EMPBE_Please_Upload_Video'));
                            }
                          this.VideoAndImgScrollToError(refOBject.$el,650);
                          }
                          resolve(false);
                          return;
                  }
                }

            }
         });
      }
      resolve(true);
    })
  },
  //必填验证 MediaUploader
  async validateMedia(data,preStatus, isSkipAlert = false){
    return new Promise((resolve, reject) => {
      if(this.temp_MediaListRef.length>0)
      {
        let isValid = true;
        let firstInvalidRef = null;
        
        this.temp_MediaListRef.forEach(element => {
            var refOBject;
            if(element.includes("."))
            {
              var obj =this.$parent.$parent;
              var refOBjectSplit = element.split('.');
              refOBjectSplit.forEach(item => {
                obj=obj?.$refs[item];
              });
              refOBject =obj;
            }else
            {
              refOBject =this.$parent.$parent.$refs[element];
            }

            if(refOBject)
            {
              const validateOne = (item) => {
                // Check if component has isRequired prop and it's true
                var isRequired = item.isRequired !== undefined ? item.isRequired : false;
                
                if(isRequired)
                {
                  // Check MediaArray or temp_mediaArray
                  var mediaArray = item.imgBtnArr || [];
                  
                  if(!mediaArray || mediaArray.length < 1){
                    isValid = false;
                    //记录他的ref内容就行
                    data.push(element);
                    //触发一次样式必填 (if component supports IsRequiredStyle)
                    if(item.IsRequiredStyle !== undefined) {
                      item.IsRequiredStyle=true;
                    }
                    // Keep track of first invalid ref for scrolling
                    if(!firstInvalidRef) {
                      firstInvalidRef = item;
                    }
                  }
                }
              };

              if(Array.isArray(refOBject)) {
                refOBject.forEach(item => validateOne(item));
              } else {
                validateOne(refOBject);
              }
            }
         });
         
         if(!isValid && preStatus && firstInvalidRef){
           // Use appropriate message based on mediaType, fallback to Photo message
           var mediaType = firstInvalidRef.mediaType || 'image';
           var alertMessage = mediaType === 'video' 
             ? this.$t('lbl_EMPBE_Please_Upload_Video')
             : this.$t('lbl_EMPBE_Please_Upload_Photo');
            if (!isSkipAlert) {
              this.$Alert(0,alertMessage);
            }
           this.$nextTick(() => {
             this.ScrollToMediaUploader(firstInvalidRef.$el);
           });
         }
         
         resolve(isValid);
      } else {
        resolve(true);
      }
    });
  },
   //必填验证 产品类别
  async validateProductCat(data, isSkipAlert = false) {
    return new Promise((resolve, reject) => {
     if(this.productCatsRef.length>0)
      {
        let isValid = true;
        let idx=0;
        for (let element of this.productCatsRef) { 
          idx=idx+1;            
          var refOBject =this.$parent.$parent.$refs[element];
          if(refOBject){ 
            if((!refOBject.getAttribute('selectedvalue') || refOBject.getAttribute('selectedvalue')=='0')){
                 isValid=false;  
              }
              if(isValid==false)
              { 
                  //记录他的ref内容就行
                  data.push(element); 
                  refOBject.IsRequiredStyle=true; 

                  //如果验证通过，隐藏提示文字
                if(isValid==false) {
                  if(idx==1){
                //  setTimeout(() => {
                //    const requireElement = document.getElementById('btnAddCat_require');
                //     if(requireElement) {
                //       requireElement.style.display='block';
                //     }
                //  }, 400); 
                
                }else if(idx==2){
                  // setTimeout(() => {
                  //   const requireElement = document.getElementById('btnAddCat_requireSub');
                  //   if(requireElement) {
                  //     requireElement.style.display='block';
                  //   }
                  // }, 400);
                  
                }

                  if (!isSkipAlert) {
                    this.$Alert(0,this.$t('Lbl_SelectSearchProductCat'));
                  }
                  this.VideoAndImgScrollToError(refOBject,600);
                }
              } 
           }
        }
        
        resolve(isValid);
      } else {
        //如果没有需要验证的产品类别，隐藏提示
        // const requireElement = document.getElementById('btnAddCat_require');
        // if(requireElement) {
        //   requireElement.style.display='none';
        // }
        //  const requireElement2 = document.getElementById('btnAddCat_requireSub');
        // if(requireElement2) {
        //   requireElement2.style.display='none';
        // }
        resolve(true);
      }
    })
  },
  scrollToError(data)
  {
    try {
          console.log("进来验证的元素",Object.keys(this.$refs.PublicVaild.fields),this.$refs.PublicVaild.fields)
            for (const key of Object.keys(this.$refs.PublicVaild.fields)) {
              if (this.$refs.PublicVaild.fields[key].invalid) {
                data.push(key);
                var element = this.$refs.PublicVaild.refs[key].$el;
                this.VideoAndImgScrollToError(element,0);
              }
            }
          } catch (ex) {
          }
  },
  VideoAndImgScrollToError(element,top){
    if (!element) return;

    // 查找最近的可滚动父容器
    const findScrollableParent = (el) => {
      let parent = el.parentElement;
      while (parent && parent !== document.body) {
        const style = window.getComputedStyle(parent);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;
        const isScrollable = 
          (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') ||
          (overflowX === 'auto' || overflowX === 'scroll' || overflowX === 'overlay');
        
        if (isScrollable) {
          const hasVerticalScroll = parent.scrollHeight > parent.clientHeight;
          const hasHorizontalScroll = parent.scrollWidth > parent.clientWidth;
          if (hasVerticalScroll || hasHorizontalScroll) {
            return parent;
          }
        }
        parent = parent.parentElement;
      }
      return null;
    };

    const scrollableParent = findScrollableParent(element);
    
    if (scrollableParent) {
      // 优先滚动内部容器
      const containerRect = scrollableParent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      
      // 计算元素相对于容器的位置
      const elementTopInContainer = elementRect.top - containerRect.top + scrollableParent.scrollTop;
      
      // 计算需要滚动的距离，确保有顶部空间
      const scrollTarget = elementTopInContainer - top;
      
      // 确保滚动目标在有效范围内
      const maxScroll = scrollableParent.scrollHeight - scrollableParent.clientHeight;
      const finalScrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));
      
      // 平滑滚动容器
      scrollableParent.scrollTo({
        top: finalScrollTarget,
        behavior: 'smooth',
      });
    } else {
      // 如果没有找到可滚动容器，滚动 body
      const viewportHeight = window.innerHeight;
      const targetElementRect = element.getBoundingClientRect();
      const scrollY = window.scrollY || document.documentElement.scrollTop;
 
      // 计算滚动到的位置，确保有顶部空间
      const scrollTarget = targetElementRect.top + scrollY - viewportHeight + top;
 
      // 确保滚动目标不会小于 0
      const finalScrollTarget = Math.max(0, scrollTarget);
 
      // 平滑滚动到计算出的位置
      window.scrollTo({
        top: finalScrollTarget,
        behavior: 'smooth',
      });
    }
  },
  ScrollToMediaUploader(element){
    if(element){
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }, 100);
    }
  },
  reset(){
    if(this.$refs.PublicVaild){
    this.$refs.PublicVaild.reset()
    }
    
  },
}
}
</script>
